/* 商品ページ：数量セレクタを自動挿入（＋/−付き） */
(function(){
  document.addEventListener('DOMContentLoaded', function(){
    var body = document.body;
    if (!body || !body.classList.contains('template--product')) return;

    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    if (!forms.length) return;

    // 「カートに追加」ボタンが可視かどうかを判定
    function dcgIsVisible(el){
      if (!el) return false;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      if (el.offsetWidth <= 0 && el.offsetHeight <= 0 && el.getClientRects().length === 0) return false;
      return true;
    }

    forms.forEach(function(form){
      if (form.dataset.dcgQtyInjected === 'true') return;
      form.dataset.dcgQtyInjected = 'true';

      var submitBtn = form.querySelector('button[type="submit"], [type="submit"], button[name="add"], .product-buy-buttons--cta');

      // カートに追加が表示されていない場合は、数量UIを挿入しない
      if (!dcgIsVisible(submitBtn)) return;

      // 既存の数量inputを取得 or 生成（送信用）
      var qtyInput = form.querySelector('input[name="quantity"]');
      if (!qtyInput){
        qtyInput = document.createElement('input');
        qtyInput.type = 'number';
        qtyInput.name = 'quantity';
        qtyInput.value = '1';
        qtyInput.min = '1';
        qtyInput.step = '1';
        qtyInput.inputMode = 'numeric';
        qtyInput.pattern = '[0-9]*';
        qtyInput.style.display = 'none';
        form.appendChild(qtyInput);
      } else {
        qtyInput.style.display = 'none';
        qtyInput.inputMode = qtyInput.inputMode || 'numeric';
        qtyInput.pattern = qtyInput.pattern || '[0-9]*';
        if (!qtyInput.value) qtyInput.value = '1';
      }

      // 表示用UIを作成
      var wrap = document.createElement('div');
      wrap.className = 'dcg-qty';
  // 被り対策（隣接ボタンの上にしっかり表示）
  wrap.style.marginBottom = '12px';
  wrap.style.position = 'relative';
  wrap.style.zIndex = '2';
      var minus = document.createElement('button');
      minus.type = 'button';
      minus.className = 'dcg-minus';
      minus.setAttribute('aria-label','数量を減らす');
      minus.textContent = '−';
      var visible = document.createElement('input');
      visible.type = 'number';
      visible.name = 'quantity_display';
      visible.min = qtyInput.min || '1';
      visible.step = qtyInput.step || '1';
      visible.value = qtyInput.value || '1';
  // テーマのCSSで非表示/透明化されるのを防ぐ
  visible.style.display = 'inline-block';
  visible.style.opacity = '1';
  visible.style.visibility = 'visible';
  visible.style.background = 'transparent';
      var plus = document.createElement('button');
      plus.type = 'button';
      plus.className = 'dcg-plus';
      plus.setAttribute('aria-label','数量を増やす');
      plus.textContent = '+';
      wrap.appendChild(minus); wrap.appendChild(visible); wrap.appendChild(plus);

      // 追加位置：ボタン全体のコンテナ（.product-buy-buttons--primary）があれば、その直前に置く
      // なければ submit ボタン直前。それも無ければフォーム先頭。
      var btnContainer = submitBtn ? (submitBtn.closest('.product-buy-buttons--primary') || submitBtn) : null;
      if (btnContainer && btnContainer.parentElement){
        btnContainer.parentElement.insertBefore(wrap, btnContainer);
      } else if (submitBtn && submitBtn.parentElement){
        submitBtn.parentElement.insertBefore(wrap, submitBtn);
      } else {
        form.insertBefore(wrap, form.firstChild);
      }

      function clamp(val){
        var min = parseInt(visible.min || '1', 10) || 1;
        var maxAttr = qtyInput.getAttribute('max');
        var max = maxAttr ? parseInt(maxAttr, 10) : Infinity;
        var n = parseInt(val, 10);
        if (isNaN(n)) n = min;
        n = Math.floor(n);
        if (n < min) n = min;
        if (n > max) n = max;
        return n;
      }
      function syncToForm(val){
        var v = clamp(val);
        visible.value = v;
        qtyInput.value = v;
      }

      minus.addEventListener('click', function(){ syncToForm((parseInt(visible.value||'1',10) - 1)); });
      plus.addEventListener('click', function(){ syncToForm((parseInt(visible.value||'1',10) + 1)); });
      visible.addEventListener('change', function(){ syncToForm(visible.value); });
      qtyInput.addEventListener('change', function(){ syncToForm(qtyInput.value); });
    });
  });
})();
